import React from "react";
import styles from "./SectionHeader.module.sass";
import cn from "classnames";


const formatTitle = (title) => {
  if (title === "CamerasBarcodes") {
    return "Cameras & Barcodes";
  }
  return title.replace(/([a-z])([A-Z])/g, '$1 $2');
};
const SectionHeader = ({ title, colorClass }) => (
  <div className={cn(colorClass, styles.subtitle, "mb-[49px] mt-8")} >
    {formatTitle(title)}
  </div>
);

export default SectionHeader;